export default function (dom, opts) {
    let options = {
        buttonSel: '[data-more-images]',
        buttonTextSel: '[data-text]',
        iconSel: '.neighbouring-caret',
        iconRotateCls: 'neighbouring-caret--rotate',
        shadowCls: 'collapsible__content--shadow',
        galleryWrapperSel: ".gallery__wrapper",
        ...opts
    };

    const desktopWidth = 1024;
    const visibleImagesCount = 9;
    const baseClass = 'collapsible';
    const showMoreButton = dom.querySelector(options.buttonSel);
    const gallery = dom.querySelector(options.galleryWrapperSel);
    const galleryItems = gallery ? Array.from(gallery.children).filter(item => item.tagName === 'LI') : [];
    const hasMoreImages = galleryItems.length > visibleImagesCount;
    const hiddenItems = galleryItems.slice(visibleImagesCount);
    const content = gallery;

    if (!gallery) {
        return;
    }

    if (!hasMoreImages) {
        if (showMoreButton) {
            showMoreButton.style.display = 'none';
        }
        dom.classList.remove(`${baseClass}--collapsed`);
        return;
    }

    gallery.classList.add(`${baseClass}__content`);
    hiddenItems.forEach(item => {
        item.style.display = 'none';
    });

    const contentTransition = e => {
        content.removeEventListener('transitionend', contentTransition);
        content.style.maxHeight = '';
    };

    if (!dom.classList.contains(`${baseClass}--collapsed`) && window.innerWidth < desktopWidth) {
        dom.classList.add(`${baseClass}--collapsed`);
    }

    showMoreButton && content && showMoreButton.addEventListener('click', e => {
        e.preventDefault();

        hiddenItems.forEach(item => {
            item.style.display = '';
        });

        showMoreButton.remove();

        content.removeEventListener('transitionend', contentTransition);
        content.addEventListener('transitionend', contentTransition);

        content.style.maxHeight = `${content.scrollHeight}px`;

        setTimeout(() => {
            dom.classList.toggle(`${baseClass}--collapsed`);

        }, 25);

        return false;
    });

}
